// extracted by mini-css-extract-plugin
module.exports = {"text":"Info_text__1r_hr","link":"Info_link__1l9Q0"};